
export default function NivoTextParser({ title }) {
    try {
        var mainTitle = title.split("(")[0];
    } catch (error) {
        console.log(error);
        mainTitle = title;
    }
    return (
        <div className='text-center pt-3 h6 fw-bold'>
            {mainTitle}
        </div>);
}
